module.exports = __webpack_public_path__ + "media/images/icons/country_flags/va-88dc9bbc061ccd327f66638e67697b46.svg";